<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16 flex-row">店长绩效奖金</div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="member-header align-items">
            <el-date-picker v-model="query.dataMonth" type="month" value-format="yyyy-MM" placeholder="选择月"
              :picker-options="pickerOptions" @change="requestData" :clearable="false"></el-date-picker>
            <div>
              <el-button type="primary" @click="appeal">申诉</el-button>
              <el-button type="primary" @click="viewTotalSalary">查看总工资</el-button>
            </div>
          </div>
          <div class="plrb16">
            <el-table :data="list" :max-height="height - 265" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="shopName" label="门店名称"></el-table-column>
              <el-table-column prop="address" label="门店地址" width="auto"></el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                  <el-link type="primary" @click="details(scope.row)"
                    v-perm="{ key: 'staffKPISalary', value: 'staffKPISalary:detail' }">查看工资</el-link>
                </template>
              </el-table-column>
            </el-table>
            <!-- <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging> -->
          </div>
        </div>
      </div>
    </div>
    <detail ref="detailForm"></detail>
    <wage-appeal ref="wageForm"></wage-appeal>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import detail from "./detail.vue";
import wageAppeal from './wageAppeal.vue';
export default {
  data() {
    return {
      // url: this.$url.staffSalary.shopList,
      query: {
        dataMonth: "",
        staffId: ''
      },
      height: this.$store.getters.MainHeight,
      list: [],
      twoNextMonth: '', // 前两个月
      pickerOptions: {
        disabledDate(time) {
          let year, lastMonth;
          let date = new Date();
          let nowYear = date.getFullYear(); //当前年：四位数字
          let nowMonth = date.getMonth(); //当前月：0-11
          if (nowMonth == 0) { //如果是0，则说明是1月份，上一个月就是去年的12月
            year = nowYear - 1;
            lastMonth = 12;
          } else { //不是1月份，年份为当前年，月份本来是要减1的，但是由于`getMonth()`的月份本身就是少了1的，所以月份不用变。
            year = nowYear;
            lastMonth = nowMonth;
          }
          lastMonth = lastMonth < 10 ? ('0' + lastMonth) : lastMonth; //月份格式化：月份小于10则追加个0
          // 前一个月
          let lastYearMonth = year + '-' + lastMonth;

          // 前两个月
          const twoYear = lastYearMonth.substring(0, 4)
          const twoMonth = lastYearMonth.substring(5, 7) - 1
          let year1 = twoYear == new Date().getFullYear() && twoMonth == '' ? twoYear - 1 : twoYear
          let month1 = twoMonth == '0' ? '12' : twoMonth
          let twoNextMonth = year1 + '-' + month1

          // 设置日期范围
          var minDate = new Date(twoNextMonth);
          var maxDate = new Date(lastYearMonth);
          var flag = false;
          flag = time > maxDate || time < minDate;
          return flag;
        },
      },
    };
  },
  mixins: [minxin],
  components: { detail, wageAppeal },
  computed: {},

  created() {
    this.query.dataMonth = this.getLastMonth(new Date())
    this.requestData();
  },

  methods: {
    getTableData() {
      this.loading = true;
      this.$api.post(this.$url.staffKpiSalary.shopList, this.query).then((res) => {
        if (res) {
          this.list = res;
          this.loading = false;
        } else {
          this.list = [];
          this.loading = false;
        }
      }).catch(error => {
        this.list = [];
        this.loading = false;
      })
    },
    requestData() {
      this.getTableData()
    },
    details(row) {
      let parmar = {
        dataMonth: this.query.dataMonth,
        shopName: row.shopName,
        allShopFlag: false
      }
      this.$refs["detailForm"].$emit("set", parmar);
    },
    back() {
      this.$router.push("/dataList/attendancePunch");
    },
    selectChange() {
      this.query.start = 0;
      this.requestData();
    },
    viewTotalSalary() {
      console.log(1);
      let parmar = {
        dataMonth: this.query.dataMonth,
        allShopFlag: true
      }
      this.$refs["detailForm"].$emit("set", parmar);
    },
    appeal() {
      this.$refs["wageForm"].$emit("set", this.query.dataMonth);
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";

.page-head {
  height: 100%;
}

.mains-content {
  height: calc(100% - 72px);

  .member-content-box {
    background: #fff;
  }

  .member-header {

    padding: 16px;
    display: flex;
    align-items: center;
  }
}
</style>